import { createReducer, on } from '@ngrx/store';
import * as unitsActions from '../actions/units.actions';

import { Unit } from '../../interfaces/units.model';

export interface UnitState {
  entities: Array<Unit>;
  allUnits: Array<Unit>;
  loaded: boolean;
  allLoaded: boolean;
  loading: boolean;
  allLoading: boolean;
  total: number;
}

export const initialState: UnitState = {
  entities: [],
  allUnits: [],
  loaded: false,
  allLoaded: false,
  loading: false,
  allLoading: false,
  total: 0
};

const unitsReducer = createReducer(
  initialState,
  on(unitsActions.loadUnits, state => ({ ...state, loading: true })),
  on(unitsActions.loadUnitsSuccess, (state, { payload }) => {
    const units = payload.results;
    const total = payload?.total

    const entities = units.reduce((all: { [uid: string]: Unit }, item: Unit) => {
      return { ...all, [item.uid]: item };
    }, {});
    return { ...state, loading: false, loaded: true, entities, total };
  }),
  on(unitsActions.loadUnitsFail, state => ({ ...state, loading: false, loaded: false })),
  on(unitsActions.loadMoreUnits, state => ({ ...state, loading: true })),
  on(unitsActions.loadMoreUnitsSuccess, (state, { payload }) => {
    const arr1 = Object.values(state?.entities);
    const arr2 = payload?.results;
    const units = [...arr1, ...arr2];
    const total = payload?.total

    const entities = units.reduce((all: { [uid: string]: Unit }, item: Unit) => {
      return { ...all, [item.uid]: item };
    }, {});

    return { ...state, loading: false, loaded: true, entities, total };
  }),
  on(unitsActions.loadMoreUnitsFail, state => ({ ...state, loading: false, loaded: false })),
  on(unitsActions.loadAllUnits, state => ({ ...state, AllLoading: true })),
  on(unitsActions.loadAllUnitsSuccess, (state, { payload }) => {
    const units = payload.results;

    const allUnits = units.reduce((all: { [uid: string]: Unit }, item: Unit) => {
      return { ...all, [item.uid]: item };
    }, {});

    return { ...state, allLoading: false, allLoaded: true, allUnits };
  }),
  on(unitsActions.loadAllUnitsFail, state => ({ ...state, allLoading: false, allLoaded: false })),
  on(unitsActions.searchUnits, state => ({ ...state, loading: true })),
  on(unitsActions.searchUnitsSuccess, (state, { payload }) => {
    const units = payload.results;
    const entities = units.reduce((all: { [uid: string]: Unit }, item: Unit) => {
      return { ...all, [item.uid]: item };
    }, {});

    return { ...state, loading: false, loaded: true, entities };
  }),
  on(unitsActions.searchUnitsFail, state => ({ ...state, loading: false, loaded: false }))
);

export function reducer(state, action) {
  return unitsReducer(state, action);
}

export const getUnitsEntities = (state: UnitState) => state?.entities;
export const getUnitsLoading = (state: UnitState) => state?.loading;
export const getUnitsLoaded = (state: UnitState) => state?.loaded;
export const getTotalUnits = (state: UnitState) => state?.total;


export const getAllUnitsEntities = (state: UnitState) => state?.allUnits;
export const getAllUnitsLoading = (state: UnitState) => state?.allLoading;
export const getAllUnitsLoaded = (state: UnitState) => state?.allLoaded;
